<template>
  <div class="profile-wrap" :class="{ 'loading': isProcessing }">
    <div class="breadcrumb-wrap">
      <h2>Profile</h2>
      <ul class="breadcrumb">
        <li>
          <router-link :to="{name: 'Home'}"><i class="bx bxs-home"></i>Home</router-link>
        </li>
        <li>
          <router-link :to="{name: 'Dashboard'}"><i class="bx bxs-dashboard"></i>Dashboard</router-link>
        </li>
        <li>
          <span>Profile</span>
        </li>
      </ul>
    </div>
    <div class="organization-box">
      <div class="title">
        <h2>{{$t('TEXT_INFORMATION')}}</h2>
      </div>
      <div class="flex-box">
        <div class="fields fields-profile">
          <div class="field">
            <div class="field-label">{{$t('TEXT_CODE')}}</div>
            <div class="field-input">
              <el-input disabled :value="userOverview.code"></el-input>
            </div>
          </div>
          <div class="field">
            <div class="field-label">{{$t('TEXT_USERNAME')}}</div>
            <div class="field-input">
              <el-input disabled :value="userOverview.username"></el-input>
            </div>
          </div>
          <div class="field">
            <div class="field-label">Change password</div>
            <div class="field-input" style="justify-content: flex-start">
              <el-button @click="changePassword">Update new password</el-button>
            </div>
          </div>
          <div class="field">
            <div class="field-label">Two factor authentication</div>
            <div class="field-input" style="justify-content: flex-start">
              <el-button @click="enable2FA" v-if="!user.use_two_fa">{{$t('BTN_ENABLE_2FA')}}</el-button>
              <el-button @click="disable2FA" v-else>{{$t('BTN_DISABLE_2FA')}}</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="organization-box" v-if="false">
      <div class="title">
        <h2>Your KYC</h2>
      </div>
      <div class="flex-box">
        <div class="fields">
          <div class="field">
            <div class="field-label">&nbsp;</div>
            <div class="field-input">
              {{ kycTxt }}
            </div>
          </div>
          <div class="field" v-if="isNeedKyc">
            <div class="field-label">&nbsp;</div>
            <div class="field-input">
              <el-button @click="kyc">View</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="organization-box" v-if="false">
      <div class="title">
        <h2>{{$t('TEXT_API_KEY')}}</h2>
      </div>
      <div class="flex-box">
        <div class="fields">
          <div class="field" v-if="!user.use_two_fa">
            <div class="field-label">2FA</div>
            <div class="field-input">
              <el-button @click="enable2FA">{{$t('BTN_ENABLE_2FA')}}</el-button>
            </div>
          </div>
          <div class="field" v-else>
            <div class="field-label">2FA</div>
            <div class="field-input">
              <el-button @click="disable2FA">{{$t('BTN_DISABLE_2FA')}}</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      isProcessing: false,
      kycStatus: {
        NONE: 'NONE',
        SUBMITTED: 'SUBMITTED',
        REJECTED: 'REJECTED',
        APPROVED: 'APPROVED'
      }
    }
  },
  computed: {
    user () {
      return this.$store.getters.user
    },
    userOverview () {
      return this.$store.getters.userOverview
    },
    userKyc () {
      return this.$store.getters.userKyc
    },
    kycTxt () {
      if (this.userKyc.kycStatus === this.kycStatus.SUBMITTED) {
        return 'Your KYC has been submitted. Please wait for reviewing'
      } else if (this.userKyc.kycStatus === this.kycStatus.NONE) {
        return 'Please submit your KYC documents'
      } else if (this.userKyc.kycStatus === this.kycStatus.REJECTED) {
        return 'Sorry, your KYC has been rejected. Please re-submit your KYC documents'
      }
      return 'Congratulations!. Your KYC has been approved'
    },
    isNeedKyc () {
      return this.userKyc.kycStatus === this.kycStatus.NONE || this.userKyc.kycStatus === this.kycStatus.REJECTED
    }
  },
  created () {
    this.$store.dispatch('getUserKyc')
  },
  methods: {
    kyc () {
      this.$router.push({ name: 'kyc' })
    },
    changePassword () {
      this.$store.dispatch('toggleChangePasswordFormModal')
    },
    enable2FA () {
      this.$store.dispatch('request2FA').then(rs => {
        if (rs.status) this.$store.dispatch('toggle2FAForm', rs.data)
      })
    },
    disable2FA () {
      this.$prompt('Please enter one time code', 'Disable 2FA', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        inputPattern: /[0-9]+/
      }).then(({ value }) => {
        this.isProcessing = true
        this.$store.dispatch('disable2FA', { code: value }).then(rs => {
          if (rs) this.$store.dispatch('getUser')
        }).finally(() => {
          this.isProcessing = false
        })
      }).catch(() => {
      })
    }
  }
}
</script>
